/**
 * Services
 * Register Angular resource services
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @author:   Cyrill N KALITA
 */

require('./SummaryController.js');
require('./BudgetAllocationController.js');
require('./ProgramMonthlyCostsController.js');
require('./ProgramMonthlyCountsController.js');
require('./ProgramSummaryController.js');
require('./ProgramTopSpeakersController.js');
